var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8766 9.78027L13.3395 6.764H10.4453V4.80664C10.4453 3.98145 10.8496 3.17708 12.1458 3.17708H13.4616V0.609049C13.4616 0.609049 12.2676 0.405273 11.126 0.405273C8.74251 0.405273 7.18457 1.84994 7.18457 4.46517V6.764H4.53516V9.78027H7.18457V17.0719H10.4453V9.78027H12.8766Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.1462c87e1dbfa7215425b9429eb42455.svg";
export { ForwardRef as ReactComponent };